import { Link, useLocation, useParams, useSearchParams } from 'react-router-dom'
import { Card, CardHeader } from '../../components/ui/Card'
import { StoreAuditTransactionDetail } from './StoreAuditTransactionDetail'
import { isValidTransactionRef, storeAuditPath, type AuditNavState } from './storeAuditRoutes'

export default function StoreAuditTransactionDetailPage() {
  const { storeId: storeIdParam, txRef: txRefParam } = useParams()
  const storeId = storeIdParam != null ? Number(storeIdParam) : NaN
  const txRef = txRefParam != null ? decodeURIComponent(txRefParam) : ''
  const invalidStore = !Number.isFinite(storeId) || storeId < 1
  const invalidRef = !isValidTransactionRef(txRef)

  const [searchParams] = useSearchParams()
  const location = useLocation()
  const navState = (location.state as AuditNavState | null) ?? {}

  const backTo = invalidStore ? '/withdrawals' : storeAuditPath(storeId, searchParams)
  const storeName = navState.storeName ?? `Store #${storeId}`

  return (
    <div className="mx-auto w-full max-w-6xl space-y-8 pb-10">
      <Card padding={false} className="overflow-hidden">
        <div className="border-b border-border bg-gradient-to-br from-muted/40 via-muted/20 to-transparent px-6 py-6 sm:px-8 sm:py-8 [&>div]:mb-0">
          <CardHeader
            title="Transaction detail"
            description={`Investigate ledger, POS, and withdrawal activity for ${storeName}.`}
          />
        </div>

        <div className="space-y-6 px-6 py-6 sm:px-8 sm:pb-8">
          <div className="flex flex-wrap items-center gap-3 text-sm">
            <Link to={backTo} state={navState} className="text-primary underline-offset-4 hover:underline">
              ← Back to audit list
            </Link>
            <Link to="/withdrawals" className="text-muted-foreground underline-offset-4 hover:text-foreground hover:underline">
              Withdrawals
            </Link>
          </div>

          {invalidStore || invalidRef ? (
            <p className="text-sm text-destructive" role="alert">
              {invalidStore ? 'Invalid store in URL.' : 'Invalid transaction reference in URL.'}
            </p>
          ) : (
            <StoreAuditTransactionDetail storeId={storeId} transactionRef={txRef} backTo={backTo} navState={navState} />
          )}
        </div>
      </Card>
    </div>
  )
}
